import { Card, CardBody, Col, Row } from "reactstrap";
import { UsersTitle } from "../../../../Constants/Constants";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import ReactApexChart from "react-apexcharts";
import { UsesChart } from "../../../../Data/General/Widgets/Chart";

const Uses = () => {
  return (
    <Col xl="7" lg="12" className="xl-50 box-col-7">
      <div className="small-chart-widget">
        <Card>
          <CommonCardHeader title={UsersTitle} />
          <CardBody>
            <div className="chart-container">
              <Row>
                <Col xs="12">
                  <div id="chart-widget9">
                    <ReactApexChart options={UsesChart} series={UsesChart.series} height={320} type="bubble" />
                  </div>
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>
      </div>
    </Col>
  );
};

export default Uses;
